import { render, staticRenderFns } from "./orderMgtyw.vue?vue&type=template&id=330c5e18&scoped=true&"
import script from "./orderMgtyw.vue?vue&type=script&lang=js&"
export * from "./orderMgtyw.vue?vue&type=script&lang=js&"
import style0 from "./orderMgtyw.vue?vue&type=style&index=0&id=330c5e18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c5e18",
  null
  
)

export default component.exports